/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */

import PatentService from '../Patent/PatentService';

class SequenceService extends PatentService {}

export default SequenceService;
